var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{class:_vm.buttonClass,attrs:{"type":_vm.type,"icon":_vm.icon,"size":_vm.n_size,"title":_vm.title,"ghost":_vm.ghost,"loading":_vm.loading,"disabled":_vm.disabled,"custom-icon":_vm.customIcon,"shape":_vm.circle ? 'circle' : null},on:{"click":function($event){return _vm.$emit('on-click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }